import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f6e7041&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2f6e7041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e7041",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6e7041')) {
      api.createRecord('2f6e7041', component.options)
    } else {
      api.reload('2f6e7041', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f6e7041&scoped=true&", function () {
      api.rerender('2f6e7041', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/buyer/components/comCart/index.vue"
export default component.exports